module.exports = __webpack_public_path__ + "fonts/hinted-Atma-Regular.3cf68ca7.ttf";